var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-ticket-container"},[_c('AirTicketSearch',{attrs:{"searchInfo":_vm.listQuery}}),_vm._v(" "),_c('div',{staticClass:"page-products-block row-flex jsb"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }